export default function(location: Location) {
  //content|contentLibrary|course|preparation
  const path = `${location.origin}/(content|contentLibrary|course|preparation)`;
  const regx = new RegExp(path);
  const currentPath = location.origin + location.pathname;
  return regx.test(currentPath);
  // return new RegExp(/content|contentLibrary|course|preparation/).test(location.href);
}
